module.exports = __webpack_public_path__ + "04_glasses_brown.5fc37a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/04_glasses_brown.png
// module id = sL84
// module chunks = 0